
// 新接口
import axios from 'axios'
import Encode from './encode'
import storage from 'storejs'
// 神策埋点 start
import sa from 'sa-sdk-javascript';
import {
    Toast
} from 'mint-ui'
import store from './../../store'
import { toLoginByAppOrH5 } from './../../utils/loginByAppOrH5'
let from4 = null



// 6.5接口新地址
export const apiNew = function (url, body, uid, session, buried, buriedPointReset) {
    console.log(process.env, 'process.env----------111')
    //   var getEncodeUrl = getUrlData('data')
    //   let decodeUrl = JSON.parse(Encode.decodeFuc(decodeURIComponent(getEncodeUrl)));
    // console.log(decodeUrl)
    const CancelToken = axios.CancelToken
    const YszAppInfo = JSON.parse(localStorage.getItem('YszAppInfo'))
    console.log('body--apiNew', body);
    console.log('YszAppInfo', YszAppInfo);

    const headers = {
        "brand": "",
        "guid": YszAppInfo&&YszAppInfo.guid ? YszAppInfo.guid : window.uuid, // 必传
        "model": "",
        "platform": (YszAppInfo&&YszAppInfo.platform) || 'WeChat',
        "sysVersion": "",
        "time": parseInt(+new Date() / 1000),
        "uid":YszAppInfo&& YszAppInfo.uid ? YszAppInfo.uid : -1, // 必传
        "version": YszAppInfo&&YszAppInfo.version ? YszAppInfo.version : '5.9.0', // 必传
        "session": YszAppInfo&&YszAppInfo.session ? YszAppInfo.session : '',
        "BG_DEBUG": 1, // 提示服务器加密
    }
    // const data = {
    //   ...body

    // }
    // if (buried) {
    //     data.buriedPoint = {
    //         "contentType": buried.contentType ? buried.contentType : -1, //内容类型	int	-1,默认 1,推广/外连接 2,视频 3,文章 4,活动 5,专题 6,频道 7,话题 8,视频专题 10,兑吧 11,广告 12,分组 13,系列课 14,其它
    //         "channelSource": buried.channelSource ? buried.channelSource : -1, //渠道来源	int	-1,默认 1,微信好友 2,微信朋友圈 3,URL 4,二维码  5.其它
    //         "browseSource": buried.browseSource >= 0 ? buried.browseSource : -1, //浏览来源	int	-1,默认 0,列表 1,相关 2,推送 3,banner条 4,分享 5,站内分享 6,站内信 7,搜索 8,个人主页 9,收藏 10,观看历史 11,WEB 12,首页弹框 13,splash 14,短信
    //         "shareEntrance": buried.shareEntrance ? buried.shareEntrance : -1, //分享入口	int	-1,默认 1,右上角 2,底部 3,文章结尾 4.其它
    //         "shareChannel": buried.shareChannel ? buried.shareChannel : -1, //分享渠道	int	-1,默认 0,手机 1,游戏 2,微信 3,QQ 4,微博 5,其它
    //         "leaveType": buried.leaveType ? buried.leaveType : -1, //离开方式	int	-1,默认 1,返回按钮 2,划屏 3,双击退出 4,其他
    //         "contentLabel": buried.contentLabel ? buried.contentLabel : -1, //内容标签	int	-1,默认 1,固定位置 2,推荐 3,置顶 4,其它
    //         "tabName": buried.tabName >= 0 ? buried.tabName : -1, //tab名称	int	-1,默认 0,阅读 1,直播 2,课程 3,我
    //         "leaveTabType": buried.leaveTabType ? buried.leaveTabType : -1, //离开tab类型	int	-1,默认0,切换tab 1,退到后台
    //         "payChannel": buried.payChannel >= 0 ? buried.payChannel : -1, //到账平台	int	-1,默认0,微信 1,支付宝 2,余额
    //         "readOperType": buried.readOperType ? buried.readOperType : -1, //阅读设置类型	int	-1,默认1,字体大小
    //     };
    // }
    // if (buriedPointReset) {
    //     data.buriedPointReset = {
    //         "sourceLocation": buriedPointReset.sourceLocation ? Number(buriedPointReset.sourceLocation) : -100, // 站内浏览来源 0-feed流，1-相关阅读，2-收藏，3-历史，4-专栏，5-会议，6-搜索列表，7-推送，8-站内信，9-广告（banner，弹窗、启动页、搜索关键词、文章详情页内链、置顶位、推广位）
    //         "placeSource": buriedPointReset.placeSource ? Number(buriedPointReset.placeSource) : -100, // 渠道来源 1-APP站内，2-官网（本期不埋），3-微信好友，4-微信朋友圈，5-短信，6-微信矩阵，7-直接访问，8-微信专栏，9-微信会议，10-mis后台查看
    //     }
    //     if (buriedPointReset.fromUid) {
    //         // 分享人UID
    //         data.buriedPointReset.fromUid = buriedPointReset.fromUid
    //     }
    //     if (buriedPointReset.keywordSource) {
    //         //1-热门词搜索、2-历史词搜索、3-联想词搜索、4-输入词搜索
    //         data.buriedPointReset.keywordSource = buriedPointReset.keywordSource
    //     }
    //     if (buriedPointReset.searchSourceAll) {
    //         // 唤起输入框位置
    //         data.buriedPointReset.searchSourceAll = buriedPointReset.searchSourceAll
    //     }
    //     if (buriedPointReset.subscribeSource) {
    //         // 直播间关注来源
    //         data.buriedPointReset.subscribeSource = Number(buriedPointReset.subscribeSource)
    //     }
    // }

    /* console.log('请求guid：', data.guid);
    console.log('请求session：', data.session);
    console.log('data',url, data); */
    console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', body)
    return axios({
        method: 'post',
        url: window.API_ROOT_NEW + url,
        headers: { ...headers },
        data: body,
        // data: data, // 现阶段没有加密
        cancelToken: new CancelToken(function executor(cancel) {
            // 2.将cancel token存入列表
            if (url === 'user/searchHospitalList') {
                window.axiosPromiseArr.push({
                    cancel
                })
            }
        })
    }).then(function (res) {
      console.log(res,397);
        let getData = res.data;
        let dataObj = getData
        // let decodeGetData = JSON.parse(Encode.decodeFuc(getData.data)); //解密data   获取的是字符串
        // let decodeGetData = getData; //解密data   获取的是字符串
        // console.log(decodeGetData);
        console.log(`%c 响应：${url}`, 'color: green;font-size:16px;', dataObj.body)
        return dataObj.body

    }).
        catch(function (res) {
            console.log(res,666)
        })
}



// WEBPACK FOOTER //
// ./src/server/api/apiNew.js